import { RootState } from "../root/redux.types";

export const selectUser = (state: RootState) => state.user;

export const selectMemberIdentifier = (state: RootState) =>
  state.user.memberIdentifier;

export const selectMyInfoCodeVerifier = (state: RootState) =>
  state.user.codeVerifier;
